import React, { useState } from 'react';
import { SafeForm } from '../SafeForm';
import { Mail, Check, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const EmailCapture = ({ session, onSaved }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (session.lead_submitted) return null;

  const submit = async () => { setBusy(true); setError('');
    try {
      const r = await fetch(`${API}/api/visualizer/sessions/${session.id}/email`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, firstName: name }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.detail || 'Versturen mislukt'); }
      onSaved(await r.json());
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };

  if (session.email_saved) {
    return (
      <p className="flex items-center gap-2 text-sm text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-xl px-4 py-3" data-testid="email-saved">
        <Check className="h-4 w-4" />Uw ontwerpen zijn onderweg naar uw mailbox. Toon ze gerust aan uw gezin.
      </p>
    );
  }
  return (
    <SafeForm onValidSubmit={submit} className="flex flex-col md:flex-row md:items-end gap-3 rounded-xl border border-[#3a190b]/15 bg-white p-4" data-testid="email-capture-form">
      <div className="flex-1">
        <p className="text-sm font-semibold text-[#202020] flex items-center gap-2 mb-2"><Mail className="h-4 w-4 text-[#3a190b]" />Ontvang uw ontwerpen per e-mail</p>
        <div className="flex flex-col sm:flex-row gap-2">
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Voornaam" className="sm:w-40 rounded-lg border border-[#3a190b]/20 px-3 py-2 text-sm" data-testid="email-capture-name" />
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="uw@email.be" className="flex-1 rounded-lg border border-[#3a190b]/20 px-3 py-2 text-sm" data-testid="email-capture-input" />
        </div>
        {error && <p className="text-xs text-red-600 mt-1" data-testid="email-capture-error">{error}</p>}
      </div>
      <button type="button" data-submit="true" disabled={busy} className="inline-flex items-center justify-center gap-2 bg-[#3a190b] hover:bg-[#500000] text-white px-5 py-2.5 rounded-full text-sm font-semibold disabled:opacity-60" data-testid="email-capture-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}Stuur mijn ontwerpen
      </button>
    </SafeForm>
  );
};

export default EmailCapture;
